import React from 'react';

import { MenuItem } from 'primereact/menuitem';

export const menuItemRenderer = (item: any, options: any) => {
	const isItemActive = item.activeKeys?.includes(item.route);
	const isActivePill = isItemActive && options.leaf;
	return (
		<a
			href={item.route}
			className={`cursor-pointer flex items-center px-3 py-2.5 rounded-lg transition-all duration-150 ${
				isActivePill
					? 'bg-[var(--color-sidebar-active-bg)]'
					: 'hover:bg-[var(--color-sidebar-hover-bg)]'
			}`}
			onClick={options.onClick}
		>
			<div className="flex items-center gap-2.5">
				<span
					className={`text-lg ${
						isActivePill
							? 'text-[var(--color-sidebar-active-text)]'
							: isItemActive
								? 'text-[var(--color-sidebar-text)]'
								: 'text-[var(--color-sidebar-text-muted)]'
					}`}
				>
					{item.icon}
				</span>
				<span
					className={`text-sm ${
						isActivePill
							? 'text-[var(--color-sidebar-active-text)] font-semibold'
							: isItemActive
								? 'text-[var(--color-sidebar-text)] font-semibold'
								: 'text-[var(--color-sidebar-text)] font-medium'
					}`}
				>
					{item.label}
				</span>
			</div>
			{item.items && (
				<span
					className={`ml-auto pi ${options.active ? 'pi-angle-up' : 'pi-angle-down'} text-xs text-[var(--color-sidebar-text-muted)]`}
				/>
			)}
		</a>
	);
};

export const getActiveKeys = (items: MenuItem[]) => {
	let keys: any = {};
	items.forEach((item: Record<string, any>) => {
		if (item.items && item.activeKeys?.includes(item.route)) {
			keys[item.key] = true;
			keys = {
				...keys,
				...getActiveKeys(item.items)
			};
		}
	});
	return keys;
};
